
            const data = {"name":"ic_down","data":{"width":"13","height":"8","viewBox":"0 0 13 8","data":"<path pid=\"0\" d=\"M1.5 1.5l5 5 5-5\" _stroke=\"#667085\" stroke-width=\"1.667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#667085"}],"stopColors":[]}}
        
                module.exports = data
                